"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarkOfTheKunirEffectHandler = exports.MarkOfTheKunirEffectArgs = void 0;
const Duration_1 = require("../../Duration");
const enums_1 = require("../../enums");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
const MaxAttributeIncrease_1 = require("./MaxAttributeIncrease");
class MarkOfTheKunirEffectArgs {
    constructor(agility, poisonDamagePercentIncrease) {
        this.agility = agility;
        this.poisonDamagePercentIncrease = poisonDamagePercentIncrease;
        this.__type = EffectType_1.EffectType.MarkOfTheKunir;
        this.__typeName = "MarkOfTheKunir";
        this.name = "MarkOfTheKunir";
        this.harmful = false;
    }
}
exports.MarkOfTheKunirEffectArgs = MarkOfTheKunirEffectArgs;
MarkOfTheKunirEffectArgs.CustomText = "Increased agility and poison damage.";
let MarkOfTheKunirEffectHandler = class MarkOfTheKunirEffectHandler {
    apply(sequence, container, state) {
        state.meta.effectIds = container.applyBuffs({
            sequence,
            creatorId: state.creatorId,
            targetId: state.targetId,
            hidden: true,
            effects: [
                {
                    duration: Duration_1.Duration.Permanent,
                    effect: new MaxAttributeIncrease_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Power, state.args.agility),
                    supernatural: true
                },
                {
                    duration: Duration_1.Duration.Permanent,
                    effect: new MaxAttributeIncrease_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.PoisonDamageIncrease, state.args.poisonDamagePercentIncrease),
                    supernatural: true
                }
            ]
        });
    }
    remove(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        (state.meta.effectIds || []).forEach(effectId => container.cancelEffect(sequence, effectId));
    }
};
MarkOfTheKunirEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.MarkOfTheKunir)
], MarkOfTheKunirEffectHandler);
exports.MarkOfTheKunirEffectHandler = MarkOfTheKunirEffectHandler;
